<template>
    <div class="extended-contact-box-container" :class="config.theme">
        <div class="content-container" v-if="!!contact">
            <img v-if="contact.image" class="contact-image" :src="contact.image" />
            <div class="contact-details">
                <div class="contact-name">{{ contact.name }}</div>
                <div class="contact-function">{{ contact.function }}</div>
                <div class="contact-phone" v-if="contact.phone">{{ contact.phone }}</div>
                <div class="spacer small-spacer"></div>
                <button class="contact-cta hoverable" @click="showContactForm">{{ labels.get('Get in contact') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import { FlatButton } from "clariant-vue3-forms";

export default {
    name: "ExtendedContactBox",
    components: {
        FlatButton
    },
    props: ["contact"],
    data() {
        return {
            labels: ServiceManager.getService(this, "Labels"),
            state: ServiceManager.getService(this, "State"),
            config: ServiceManager.getService(this, "Config"),
        }
    },
    mounted() {
    },
    beforeUnmount() {
        this.state.unsubscribe(`${this.$options._componentTag}-${this._uid}`);
    },
    methods: {
        showContactForm() {
            this.$emit("showContactForm", this.requestType);
        },
        getImageUrl() {
            let url = this.config.defaultContactImage;
            if (this.contact && this.contact.image) {
                url = this.contact.image;
            }
            return url;
        }
    }
}
</script>

<style scoped>
.extended-contact-box-container {
    container-type: inline-size;
}

.content-container {
    height: 320px;
    display: flex;
    flex-direction: row;
}

.contact-image {
    height: 100%;
    width: 100%;
    max-width: 393px;
    min-width: 197px;
    object-fit: cover;
    object-position: center;
}

.contact-details {
    padding: 40px 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
}

.contact-name {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 40px;
    line-height: 48px;
    font-weight: 500;
    padding-bottom: 32px;
}

.small-spacer {
    display: none;
}

.contact-function,
.contact-phone {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-size: 18px;
    font-weight: 325;
}

.contact-cta {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    padding: 10px 16px;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    cursor: pointer;
    margin-top: 32px;
}

@container (max-width: 960px) {

    .extended-contact-box-container .contact-name {
        font-size: 24px;
        line-height: 28px;
        font-weight: 500;
        padding-bottom: 8px;
    }

    .extended-contact-box-container .content-container {
        height: 236px;
    }

    .extended-contact-box-container .contact-details {
        padding: 32px;
    }

    .extended-contact-box-container .contact-image {
        max-width: 197px;
    }

    .extended-contact-box-container .contact-function,
    .extended-contact-box-container .contact-phone {
        font-size: 14px;
    }

    .extended-contact-box-container .small-spacer {
        display: block;
    }

    .extended-contact-box-container .contact-cta {
        margin-top: 16px;
    }
}

@container (max-width: 480px) {
    .extended-contact-box-container .contact-image {
        display: none;
    }
}
</style>
